import Button from "@components/base/button";
import styles from "./notes.module.scss";
import CommentImg from "@assets/images/icons/comment.svg";
import { useEffect, useState } from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { getApiUrl } from "@utils/baseUrl";
import axios from "axios";
import { toast } from "react-toastify";
import LoadingSkeleton from "@shared/LoadingSkeleton";
import { useLocation } from "react-router-dom";
import { intelAPIEndpoints } from "@routes/intel/dashboard/const";
import { Tooltip } from "react-tooltip5";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";
import { generateTrackingObject } from "@core/global/global-country-functions";
import trackingEventDictionary from "@core/dictionary/tracking-event";
import { useDispatch } from "react-redux";
import { getSidebarCountData } from "@redux/Sidebar/sidebarCount.action";
import moment from "moment";

const TYPE = {
  delete: "delete",
  update: "update",
  add: "new_added",
};

const Notes = ({ comingFrom = "", showText = true, count, id = "", profileDetails, profileType, type, tradeDirection, country, dataSource, setIsFavourite, customValue, bolType }) => {
  const [inputNote, setInputNote] = useState("");
  const [notesData, setNotesData] = useState([]);
  const [disableAddNew, setDisableAddNew] = useState(false);
  const [currentType, setCurrentType] = useState({});
  const [loading, setLoading] = useState(true);
  const [noteCount, setNoteCount] = useState(count);
  const { search: searchUrlParams } = useLocation();
  const [notesId, setNotesId] = useState(id);
  const profileName = new URLSearchParams(searchUrlParams).get("redirectingProfile") || new URLSearchParams(searchUrlParams).get("profileName");
  const dispatch = useDispatch();
  const newNote = {
    notes: "",
    id: "",
  };

  useEffect(() => {
    setNotesId(id);
    setNoteCount(count);
  }, [count, id]);

  const PendoKeysMapper = {
    logistics: "logistic_company_profile",
    company: "company_profile",
    tradeLanes: "trade_lane_profile",
    ports: "port_profile",
    shipments: "view_shipments",
  };

  const callingTrackingEvents = (eventName) => {
    let finalEventName = PendoKeysMapper[profileType];
    if (comingFrom === "dashboard") {
      finalEventName = finalEventName + "_page_" + eventName;
    } else {
      finalEventName = finalEventName + "_" + eventName;
    }
    trademoTrackingEvents(finalEventName, generateTrackingObject("intel", !!window && !!window.location && !!window.location.pathname && window.location.pathname !== "" ? window.location.pathname : "", ""));
  };

  const getRequestObj = async () => {
    const requestObj = [];
    const item = profileDetails;
    if (!!item && (!!item.key || item.company_name || !!item.shipper_company_id || !!item.consignee_company_id || !!item.company_id || !!item.hashed_id || item.redirection_id || item.name || item.elastic_data_id)) {
      let tempObj = {};
      tempObj.isAppendTags = true;
      tempObj.is_merged = false;
      tempObj.company_name = item?.company_name ? item.company_name : item.name;
      tempObj.type = profileType;
      if (tradeDirection || item.trade_direction) tempObj.trade_direction = tradeDirection ? tradeDirection : item.trade_direction; // this helps in identifying import or export in dashboard, expected value import or export
      if (country || item.company_country) tempObj.company_country = country ? country : item.company_country; // this helps in identifying company profile redirection in dashboard, expected value country name in small letters
      if (dataSource || item.data_source) tempObj.data_source = dataSource ? dataSource : item.data_source;
      if (type) tempObj.company_type = type.toUpperCase() === "EXPORTER" || type.toUpperCase() === "EXPORT" ? "E" : "I";
      if (item.is_merged) tempObj.is_merged = true;
      tempObj.company_id = item.elastic_data_id[0];
      if (profileName || bolType) {
        tempObj.redirectionKey = bolType || profileName;
      }
      if (customValue) {
        tempObj.custom_value = customValue;
      }
      tempObj.type = profileType;
      tempObj.notes = inputNote;
      if (tempObj?.company_id) {
        requestObj.push(tempObj);
      }
    }
    const filteredApiUrl = intelAPIEndpoints.saveFavouriteCompanies;
    try {
      const { data } = await axios.post(filteredApiUrl, requestObj);
      setNotesId(data.data.favourite_id);
      getNotesData(data.data.favourite_id);
      setIsFavourite(true);
      toast.success("Note added successfully");
      dispatch(getSidebarCountData());
      setLoading(false);
    } catch {
      toast.error("Something went wrong!");
    }
  };

  const addNewNote = (type) => {
    if (type === "new") {
      setCurrentType(TYPE.add);
      setDisableAddNew(true);
      setNotesData([newNote]);
      setInputNote("");
    } else {
      let tempNewNote = [...notesData];
      tempNewNote = [newNote, ...notesData];
      setNotesData(tempNewNote);
      setDisableAddNew(true);
      setCurrentType(TYPE.add);
    }
  };

  const countRemainingWords = (data = inputNote) => {
    const MAX_ALLOWED = 500;
    return +(MAX_ALLOWED - (data?.length || 0));
  };

  const handleChange = (e) => {
    let value = e.target.value;
    if (value.length < 500) {
      setInputNote(value);
    } else {
      value = value.substring(0, 500);
      setInputNote(value);
      return false;
    }
  };
  const updateData = (e, notesData) => {
    let data = { ...notesData };
    let updateValue = e.target.value;
    if (updateValue.length < 500) {
      data.text = updateValue;
      setCurrentType(data);
    } else {
      updateValue = updateValue.substring(0, 500);
      data.text = updateValue;
      setCurrentType(data);
      return false;
    }
  };
  const getNotesData = async (noteId) => {
    setLoading(true);
    setNotesData([]);
    try {
      const { data } = await axios.post(getApiUrl("user_notebook_details"), { id: noteId });
      setLoading(false);
      if (data.data.length > 0) {
        setNotesData(data.data);
        setNoteCount(data.count);
        setDisableAddNew(false);
      } else if (data.data.length === 0) {
        addNewNote("new");
        setNoteCount(0);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const modifyNotesData = async (note_id = "", type) => {
    try {
      const payload = {
        id: note_id,
        favourite_id: notesId,
        notes: type === TYPE.update ? currentType.text.trim() : inputNote.trim(),
        action: type,
      };
      if (payload.notes || type === TYPE.delete) {
        await axios.post(getApiUrl("update_user_notebook"), payload);
        setLoading(false);
        if (type === TYPE.delete) {
          toast.success("Note deleted successfully");
        } else if (type === TYPE.update) {
          toast.success("Note updated successfully");
        } else {
          toast.success("Note added successfully");
        }
        getNotesData(notesId);
        setCurrentType({});
      } else {
        toast.warning("Notes cannot be empty!");
      }
    } catch (error) {
      setLoading(false);
    }
  };
  return (
    <div>
      <OverlayTrigger
        trigger="click"
        key={"right"}
        placement="auto"
        rootClose
        overlay={
          <Popover className={styles.popover}>
            <Popover.Content className={`${styles.popover_body} p-0`}>
              <div className={styles.notes_modal}>
                {loading ? (
                  <LoadingSkeleton shape={"rectangle"} height="200px" width="350px" />
                ) : (
                  <>
                    <Button
                      variant="secondaryWithIcon"
                      size="small"
                      icon={CommentImg}
                      iconSize="small"
                      disabled={disableAddNew}
                      onClick={() => {
                        addNewNote();
                        setInputNote("");
                        callingTrackingEvents(trackingEventDictionary.addNote);
                      }}>
                      <div className="ml-1">Add New Note</div>
                    </Button>
                    {notesData && notesData.length > 0 && notesId !== "" ? (
                      notesData.map((noteData) =>
                        noteData.notes !== "" ? (
                          <div className={`${styles.notes_container}  ${currentType[noteData.id] === TYPE.update && styles.textarea_container}`} key={noteData.id}>
                            <div className={`d-flex justify-content-between ${styles.gap_12}`}>
                              {currentType[noteData.id] === TYPE.update ? (
                                <textarea className={styles.textarea} defaultValue={noteData.notes} onChange={(e) => updateData(e, currentType)} autoFocus value={currentType[noteData.id] === TYPE.update ? currentType.text : noteData.notes} disabled={currentType[noteData.id] !== TYPE.update} />
                              ) : noteData?.notes.length > 150 ? (
                                <span className={styles.notes}>
                                  {currentType[`${noteData.id}_show`] ? noteData.notes : `${noteData?.notes?.slice(0, 150)}...`}
                                  <span
                                    className={styles.read_more}
                                    onClick={() => {
                                      setCurrentType({ [`${noteData.id}_show`]: !currentType[`${noteData.id}_show`] });
                                    }}>
                                    {currentType[`${noteData.id}_show`] ? " Show Less" : " Read More"}
                                  </span>
                                </span>
                              ) : (
                                <span className={styles.notes}>{noteData.notes}</span>
                              )}
                              {currentType[noteData.id] !== TYPE.update && (
                                <div className={`d-flex cursor-pointer ${styles.gap_12}`}>
                                  <span
                                    className={`material-symbols-outlined ${styles.favIcon}`}
                                    onClick={() => {
                                      setCurrentType({ [noteData.id]: TYPE.update, text: noteData.notes });
                                      callingTrackingEvents(trackingEventDictionary.editNote);
                                    }}>
                                    edit
                                  </span>
                                  <span
                                    className={`material-symbols-outlined ${styles.favIcon}`}
                                    onClick={() => {
                                      modifyNotesData(noteData.id, TYPE.delete);
                                      callingTrackingEvents(trackingEventDictionary.deleteNote);
                                    }}>
                                    delete
                                  </span>
                                </div>
                              )}
                            </div>
                            <div className={`d-flex justify-content-between ${styles.notes_footer}`}>
                              {currentType[noteData.id] !== TYPE.update ? (
                                <div>{moment(noteData.created_at).format("MMMM DD, YYYY")}</div>
                              ) : (
                                <>
                                  <div className={styles.footer_buttons}>
                                    <Button
                                      variant="primaryLink"
                                      size=""
                                      onClick={() => {
                                        modifyNotesData(noteData.id, TYPE.update);
                                      }}>
                                      <div>Update Note</div>
                                    </Button>
                                    <Button
                                      variant="secondaryLink"
                                      size=""
                                      onClick={() => {
                                        setInputNote("");
                                        setCurrentType({});
                                      }}>
                                      <div>Cancel</div>
                                    </Button>
                                  </div>
                                  <div className={`${countRemainingWords(currentType.text) === 0 ? styles.error_message : ""}`}>{countRemainingWords(currentType.text)} characters remaining</div>
                                </>
                              )}
                            </div>
                          </div>
                        ) : (
                          <div className={`${styles.notes_container} ${styles.textarea_container}`} key={noteData.id}>
                            <textarea className={styles.textarea} onChange={handleChange} value={inputNote} autoFocus />
                            <div className={`d-flex justify-content-between ${styles.notes_footer}`}>
                              {inputNote.length > 0 ? (
                                <div className={styles.footer_buttons}>
                                  <Button
                                    variant="primaryLink"
                                    size=""
                                    onClick={() => {
                                      modifyNotesData(notesId, TYPE.add);
                                    }}>
                                    <div>Add Note</div>
                                  </Button>
                                  <Button
                                    variant="secondaryLink"
                                    size=""
                                    onClick={() => {
                                      setInputNote("");
                                      if (noteCount === 0) {
                                        document.getElementById(`noteButtonClick${notesId}`).click();
                                      }
                                    }}>
                                    <div>Cancel</div>
                                  </Button>
                                </div>
                              ) : (
                                <div></div>
                              )}
                              <div className={`${countRemainingWords() === 0 ? styles.error_message : ""}`}>{countRemainingWords()} characters remaining</div>
                            </div>
                          </div>
                        )
                      )
                    ) : notesId === "" ? (
                      <div className={`${styles.notes_container} ${styles.textarea_container}`}>
                        <textarea className={styles.textarea} onChange={handleChange} value={inputNote} autoFocus />
                        <div className={`d-flex justify-content-between ${styles.notes_footer}`}>
                          {inputNote.length > 0 ? (
                            <div className={styles.footer_buttons}>
                              <Button
                                variant="primaryLink"
                                size=""
                                onClick={() => {
                                  getRequestObj();
                                }}>
                                <div>Add Note</div>
                              </Button>
                              <Button
                                variant="secondaryLink"
                                size=""
                                onClick={() => {
                                  setInputNote("");
                                  if (noteCount === 0) {
                                    document.getElementById(`noteButtonClick${notesId}`).click();
                                  }
                                }}>
                                <div>Cancel</div>
                              </Button>
                            </div>
                          ) : (
                            <div></div>
                          )}
                          <div className={`${countRemainingWords() === 0 ? styles.error_message : ""}`}>{countRemainingWords()} characters remaining</div>
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </>
                )}
              </div>
            </Popover.Content>
          </Popover>
        }>
        {comingFrom === "dashboard" ? (
          <div
            className="d-flex align-items-center"
            onClick={() => {
              getNotesData(notesId);
              callingTrackingEvents(noteCount ? trackingEventDictionary.viewNotes : trackingEventDictionary.takeNotes);
            }}>
            <img src={CommentImg} alt="comment" className="d-block position-relative mr-1 cursor-pointer" width={20} height={20} id={`noteButtonClick${notesId}`} data-tooltip-content={noteCount ? "View Notes" : "Take notes"} data-tooltip-id={`notes_icon`} />
            {noteCount > 0 && noteCount}
          </div>
        ) : profileType === "company" ? (
          <button
            data-tooltip-content="Add Notes"
            data-tooltip-id="notes_icon"
            className="tw-w-10 tw-h-10 tw-border tw-rounded-lg tw-bg-white tw-shadow-autoSuggestPill tw-border-gray-200"
            id={`noteButtonClick${notesId}`}
            onClick={() => {
              if (notesId) {
                getNotesData(notesId);
              } else {
                setLoading(false);
                addNewNote("new");
              }
              callingTrackingEvents(noteCount ? trackingEventDictionary.viewNotes : trackingEventDictionary.takeNotes);
            }}>
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#101828">
              <path d="M240-400h122l200-200q9-9 13.5-20.5T580-643q0-11-5-21.5T562-684l-36-38q-9-9-20-13.5t-23-4.5q-11 0-22.5 4.5T440-722L240-522v122Zm280-243-37-37 37 37ZM300-460v-38l101-101 20 18 18 20-101 101h-38Zm121-121 18 20-38-38 20 18Zm26 181h273v-80H527l-80 80ZM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240L80-80Zm126-240h594v-480H160v525l46-45Zm-46 0v-480 480Z" />
            </svg>
          </button>
        ) : (
          <Button
            variant="secondaryWithIcon"
            size={comingFrom === "company" ? "large" : "medium"}
            icon={CommentImg}
            iconSize="medium"
            id={`noteButtonClick${notesId}`}
            onClick={() => {
              if (notesId) {
                getNotesData(notesId);
              } else {
                setLoading(false);
                addNewNote("new");
              }
              callingTrackingEvents(noteCount ? trackingEventDictionary.viewNotes : trackingEventDictionary.takeNotes);
            }}>
            <div className="ml-1">{showText ? (noteCount ? "View Notes" : "Take notes") : ""}</div>
          </Button>
        )}
      </OverlayTrigger>
      <Tooltip className="trademo-tooltip" textColor="#FFFFFF" place="right" id={"notes_icon"} />
    </div>
  );
};

export default Notes;
